import React from 'react';
import { ArrowRight } from 'lucide-react';
import { NEWSLETTER_FORM_URL } from '../../data/ribbonData';

const B = 'https://customer-assets-cm19k8pv.emergentagent.net/job_1373bd47-7a24-47ca-adae-0f2fe2678f07/artifacts/';
const BG = `${B}34c9b9658e928774_IMG_9893%202.JPG`;

export const RibbonSignup = () => (
  <section className="max-w-7xl mx-auto px-5 sm:px-8 py-16 sm:py-24" data-testid="ribbon-signup">
    <div className="relative overflow-hidden rounded-[2.5rem] rb-glass p-8 sm:p-14">
      <img src={BG} alt="" className="absolute right-0 top-0 h-full w-1/2 object-cover opacity-30 hidden md:block [mask-image:linear-gradient(to_left,black,transparent)]" />
      <div className="absolute -bottom-24 -left-24 w-96 h-96 rounded-full bg-[#ff6a00]/30 blur-[100px]" />
      <div className="relative max-w-xl">
        <p className="rb-eyebrow mb-4">Join the tribe</p>
        <h2 className="rb-head text-5xl sm:text-6xl mb-5"><span className="rb-neon">New colors drop</span> <span className="rb-grad">in your inbox first.</span></h2>
        <p className="text-white/70 mb-8">Get early access to new colorways, restocks and maker inspiration from Finest Feathers.</p>
        <a href={NEWSLETTER_FORM_URL} target="_blank" rel="noopener noreferrer" data-testid="signup-btn"
          className="group inline-flex items-center gap-2 rounded-full rb-btn px-8 py-4 font-bold uppercase tracking-wider">
          Join the list <ArrowRight className="w-5 h-5 transition-transform group-hover:translate-x-1" />
        </a>
      </div>
    </div>
  </section>
);
